<div fxLayoutAlign="center start">
  <mat-card appearance="outlined" fxFlex="40" fxFlex.lt-lg="100" style="margin-top: 50px">
    <mat-card-header>
      <mat-card-title fxLayoutAlign="end end">
        <!-- Login -->
        <img src="assets/images/logo-mwi-new.jpg" style="width: 70%; max-height: 150px">
      </mat-card-title>
      <mat-card-title>
        Password reset
      </mat-card-title>
    </mat-card-header>
    <mat-card-content style="padding: 10px">
      <span>
        We've noticed that your password was recently reset by an administrator, for your own security, you are required to enter a new password for your account.
      </span>
    </mat-card-content>
    <mat-card-content fxLayout="column" *ngIf="!shouldShowLoader()">

      <form fxLayout="column" form="resetForm">
        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput appNoWhiteSpace autocomplete="off" placeholder="Password" name="password" [formControl]="frmPassword" minlenght="9"/>
          <mat-icon matSuffix>security</mat-icon>
          <mat-error *ngIf="frmPassword.hasError('required')" style="color: #d32f2f">
            Password is required
          </mat-error>
          <mat-error *ngIf="frmPassword.hasError('minlength')" style="color: #d32f2f">
            Password minimum length is 9 characters
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Confirm password</mat-label>
          <input matInput appNoWhiteSpace autocomplete="off" placeholder="Confirm Password" name="confirmPassword" [formControl]="frmConfirmPassword" minlenght="9"/>
          <mat-icon matSuffix>security</mat-icon>
          <mat-error *ngIf="frmConfirmPassword.hasError('required')" style="color: #d32f2f">
            Password confirmation required
          </mat-error>
          <mat-error *ngIf="frmConfirmPassword.hasError('minlength')" style="color: #d32f2f">
            Password minimum length is 9 characters
          </mat-error>
        </mat-form-field>
      </form>

      <div fxLayout="row" style="margin-top: 15px">
        <button mat-raised-button color="primary" (click)="onSubmitPasswordReset()" [disabled]="shouldDisableSubmitButton()" >Reset password</button>
      </div>

    </mat-card-content>
    <mat-card-content fxLayout="column" *ngIf="shouldShowLoader()" fxLayoutAlign="center center" style="height: 240px">
      <span fxFlex="100" style="padding-top: 30px">
        <mat-spinner></mat-spinner>
      </span>
      <span fxFlex="100">
        <h3>Communicating with the server...</h3>
      </span>
    </mat-card-content>
  </mat-card>
</div>
